Wee.fn.make('products', {
	init: function() {
		var $priv = this.$private,
			$filters = $('ref:filters');

		$priv.initEvents();
		$priv.hidePopoutNav();

		if (! $('.slider').length) {
			$priv.createSlider();
		}

		$.screen.map([
			{
				min: 4,
				callback: function() {
					$filters.enable();
					$('ref:html').enable();

					if ($('ref:productIndexHero').length) {
						var $indexHero = $('ref:productIndexHero'),
							source = $indexHero.data('src'),
							sourceSet = $indexHero.data('srcset');

						$indexHero.attr('src', source);
						$indexHero.attr('srcset', sourceSet);
					}
				}
			}, {
				max: 3,
				callback: function() {
					$filters.disable();
				}
			}
		]);
	},

	unload: function() {
		$.events.off(false, '.products');
	}
}, {

	/**
	 * Init events
	 *
	 * @private
	 */

	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:paginateNum': {
				click: function(e, el) {
					var query = scope.buildQuery({
						perPage: $(el).attr('data-val')
					});

					$.history.go({
						path: $.routes.uri().path + query,
						scrollTop: $('ref:productsResults')
					});
				}
			},

			'ref:filterToggle': {
				click: function() {
					$('ref:html').toggleEnable();
					$('ref:filters').toggleEnable();
				}
			},

			'ref:filterClear': {
				click: function() {
					$('ref:filterForm')[0].reset();
					$('.slider').remove();
					$('ref:filterMin').text(0);
					$('ref:filterMax').text(12);
					$('ref:useZone').val('');

					scope.createSlider();
					scope.updateFilters('', false);
				}
			},

			'ref:keywordClear': {
				click: function() {
					var queryKeys = Object.keys($.routes.uri().query);

					$('ref:keywordInput').val('');
					$('ref:html').enable();

					for (var param in queryKeys) {
						if (queryKeys[param] === 'keyword') {
							delete queryKeys[param];

							scope.updateFilters();
						}
					}
				}
			},

			'ref:filterCheckbox': {
				change: function() {
					scope.updateFilters();
				}
			},

			'ref:sortItem': {
				click: function(e, el) {
					$('ref:sortItem').each(function(el) {
						if (el.checked === true) {
							el.click();
						}
					});

					$(el).checked = true;

					scope.updateFilters();
				}
			},

			'ref:filterItem': {
				click: function() {
					scope.updateFilters();
				}
			},

			'ref:useZone': {
				keydown: function(e, el) {
					if (e.keyCode === 13 && $(el).val() !== null) {
						scope.updateFilters();
					}
				}
			},

			'ref:customCapacity': {
				keydown: function(e, el) {
					if (e.keyCode === 13 && $(el).val() !== null) {
						scope.updateFilters();
					}
				}
			},

			'ref:keywordInput': {
				keydown: function(e, el) {
					if (e.keyCode === 13 && $(el).val() !== null) {
						scope.updateFilters();
						$('ref:html').enable();
					}
				}
			},

			'ref:filterSubmit': {
				click: function() {
					var $filterSubmit = $('ref:filterSubmit');

					$(this).html('<span class="spinner"></span>').addClass('spin');

					setTimeout(function() {
						$filterSubmit
							.text('Success')
							.removeClass('spin')
							.addClass('success');

						setTimeout(function() {
							$('ref:filters').disable();
							$('ref:html').enable();
							$filterSubmit.removeClass('success').text('See Results');
							$('.spinner').remove();
						}, 500);
					}, 1000);
				}
			}
		}, {
			namespace: 'products'
		});
	},

	/**
	 * Update product filters based on query string
	 *
	 * @private
	 */
	updateFilters: function(data, query) {
		var normalizedData = query === false ? '' : this.normalizeFilters(data);

		$.history.go({
			path: Wee.routes.uri().path + '?' + decodeURI(normalizedData),
			scrollTop: $('ref:productsResults').offset().top,
			partials: '.products-list'
		});
	},

	/**
	 *	Get array of values from key in JSON object
	 *
	 * @private
	 */
	normalizeFilters: function(filters) {
		var data = $.extend($('ref:filterForm').serialize(true), filters),
			serializedForm = {};

		for (var filterList in data) {
			if (data.hasOwnProperty(filterList) && Wee.$isArray(data[filterList])) {
				serializedForm[filterList] = data[filterList].join('|');
			} else if (data[filterList] !== '') {
				serializedForm[filterList] = data[filterList];
			}
		}

		return $.serialize(serializedForm);
	},

	/**
	 * Create Omni-slider
	 *
	 * @private
	 */
	createSlider: function() {
		var scope = this;

		scope.mySlider = new Slider($('ref:filterRange')[0], {
			isDate: false,
			min: 0,
			max: 12,
			start: $.get('minAge'),
			end: $.get('maxAge'),
			overlap: false
		});

		if ($('.slider').length) {
			scope.mySlider.subscribe('start', function(data) {
				$('ref:minAge').attr('value', Math.ceil(data.left));
				$('ref:maxAge').attr('value', Math.ceil(data.right));
			});

			scope.mySlider.subscribe('moving', function(data) {
				$('ref:filterMin').text(Math.ceil(data.left));
			});

			scope.mySlider.subscribe('moving', function(data) {
				$('ref:filterMax').text(Math.ceil(data.right));
			});

			scope.mySlider.subscribe('stop', function(data) {
				$('ref:minAge').attr('value', Math.ceil(data.left));
				$('ref:maxAge').attr('value', Math.ceil(data.right));

				scope.updateFilters();
			});
		}
	},

	/**
	 * Build a query with provided object and return formatted query string
	 *
	 * @private
	 */
	buildQuery: function(obj) {
		var query = Wee.routes.uri().query;

		if (Object.keys(obj).length) {
			for (var item in obj) {
				if (obj.hasOwnProperty(item)) {
					query[item] = obj[item];
				}
			}
		}

		return '?' + $.serialize(query);
	},

	/**
	 * Hide popout nav on product index load
	 *
	 * @private
	 */
	hidePopoutNav: function() {
		var $productsLink = $('ref:productsLink'),
			$popoutNav = $('ref:popoutNav');

		if ($productsLink.isActive) {
			$productsLink.deactivate();
			$popoutNav.deactivate().disable();
		}
	}
});